import React, { Component } from "react";
import FormSummary from "@components/FormSummary";
import { message, Button, Table, Modal, Select, Input } from "antd";
import {
  channelList,
  addChannel,
  updateChannel,
  deleteChannel,
  getChannelCode,
  download
} from "@api/ChannelManage";
import { getAllTarget } from "@api/statistics";
import moment from "moment";
import bus from "@utils/bus";
import form from "./from_config.js";
import DateGroup from "@components/DateGroup";
import { store } from "../store-manager.js";

const downloadjs = require("downloadjs");
const confirm = Modal.confirm;
const Option = Select.Option;
const dateFormat = "YYYY/MM/DD hh:mm:ss";
let allTreeData = [];
let hideOptions = []
export default class ChannelManage extends Component {
  formRef = React.createRef();

  state = {
    formItems: [],
    visible: false,
    operateType: "",
    formDefaultValue: {},

    channelTree: [{ name: "全部一级渠道", id: "" }],

    name: "",
    groupId: "",
    subGroupId: "",

    tableList: [],
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    id: "",
    level: 0,
    createBegin: 0,
    createEnd: 0
  };

  componentDidMount() {
    this.getChannelList();
    this.getAllTarget()
  }

  handleFirstChannelChange(val) {
    let tempFormItems_3 = this.state.formItems;

    tempFormItems_3[3].options = this.getSecondChannelByFirstChannel(val);
  }

  getSecondChannelByFirstChannel(val) {
    let firstChannel = allTreeData.find((item) => item.id === val);
    let tempSecondChannel = [];

    if (firstChannel.sub) {
      tempSecondChannel = firstChannel.sub.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }

    return tempSecondChannel;
  }

  handleOk = async (e) => {
    let demo = this.formRef.current;

    try {
      const value = await demo.validateFields();
      const income =
        value.incomeDeductRate && Number(value.incomeDeductRate) > 100;
      const newUser =
        value.newUserDeductRate && Number(value.newUserDeductRate) > 100;
      const createUser =
        value.createUserDeductRate && Number(value.createUserDeductRate) > 100;
      if (income) {
        message.error("收入扣量不能大于100%");
        return;
      }
      if (newUser) {
        message.error("新增扣量不能大于100%");
        return;
      }
      if (createUser) {
        message.error("首次创角扣量不能大于100%");
        return;
      }
      let data = this.beforePost(value);

      this.save(data);
    } catch (err) {
      console.log(err);
    }
  };

  beforePost = (value) => {
    const { roleTp } = bus.userInfo;
    const { level } = this.state;

    let json = {
      name: value.name,
      level,
      createAcc: value.createAcc || false,
      isCooperation: value.isCooperation,
      company: {
        name: value.company || "",
        contact: value.contact || "",
        mobile: value.mobile || "",
        address: value.address || "",
      },
      createUserDeductRate: Number(value.createUserDeductRate)
    };
    if (value.hideTargetIds && value.hideTargetIds.length > 0) {
      json.hideTargetIds = value.hideTargetIds;
    }
    if (value.rewardRate) {
      json.rewardRate = Number(Number(value.rewardRate).toFixed(2));
    } else {
      json.rewardRate = 0;
    }

    if (value.codes) {
      json.code = value.codes;
    }

    if (roleTp === 5) {
      const { secondLevelChannelIds } = bus.userInfo;
      let parentId = "";

      if (secondLevelChannelIds && Array.isArray(secondLevelChannelIds)) {
        parentId = secondLevelChannelIds[0] || "";
      }

      json.parentId = parentId;
    }

    if (roleTp === 4 && level === 2) {
      const { firstLevelChannelIds } = bus.userInfo;
      let parentId = "";

      if (firstLevelChannelIds && Array.isArray(firstLevelChannelIds)) {
        parentId = firstLevelChannelIds[0] || "";
      }

      json.parentId = parentId;
    }

    if (value.parentId) {
      const { incomeDeductRate, newUserDeductRate } = value;

      json.parentId = value.parentId;
      json.incomeDeductRate = incomeDeductRate ? Number(incomeDeductRate) : -1;
      json.newUserDeductRate = newUserDeductRate ? Number(newUserDeductRate) : -1;
    }

    if (this.state.id && this.state.operateType === "edit") {
      json.id = this.state.id;
    }

    if (value.limit) {
      json.limit = Number(value.limit);
    }

    return json;
  };

  save = async (data) => {
    let res = "";

    if (data.id) {
      res = await updateChannel(data);
    } else {
      res = await addChannel(data);
    }
    if (res.data.meta.errCode === 0) {
      message.success(data.id ? "操作成功!" : res.data.data);
      this.setState({ visible: false });
      this.getChannelList(this.state.pagination.current);
    } else {
      message.error(
        `操作失败!${res.data.meta.errCode} - ${res.data.meta.errMsg}`
      );
    }
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  getChannelList = async (page) => {

    await store.hasAllChannel()
    const res = store.remote.channel

    allTreeData = res || [];
    const list = allTreeData.map((item) => ({
      name: item.name,
      id: item.id,
    }));
    const arr = allTreeData.map((item) => ({
      label: item.name,
      value: item.id,
    }));

    this.searchChannel({ current: page || 1 });

    // if (bus.userInfo.isDeducted) {
    //     this.setDeductedChannel();
    // } else {

    // }

    this.setFormItems(arr);

    this.setState({
      channelTree: [{ name: "全部一级渠道", id: "" }].concat(list),
    });
  };

  setFormItems = (data) => {
    const { roleTp } = bus.userInfo;

    if (roleTp === 1 || roleTp === 2) {
      form.formItems_2[1].options = data.slice();
      form.formItems_3[2].options = data.slice();
    }
  };

  selectChannel = (val) => {
    this.setState({ groupId: val });
  };

  getInputVal = (event) => {
    this.setState({ name: event.target.value });
  };

  searchChannel = (page) => {
    const pagination = { ...this.state.pagination };
    pagination.current = page.current;
    const { groupId, subGroupId, name, createBegin, createEnd } = this.state;
    const params = {
      page: page.current,
      size: 10,
      groupId,
      subGroupId,
      name,
    };

    if (createBegin && createEnd) {
      Object.assign(params, { createBegin, createEnd });
    }

    channelList(params).then((res) => {
      let list = [];

      if (res.data.meta.errCode === 0) {
        list = res.data.data || [];
        pagination.total = res.data.meta.paging && res.data.meta.paging.total;
      } else {
        message.error(
          `查询列表失败!${res.data.meta.errCode} - ${res.data.meta.errMsg}`
        );
      }
      this.setState({
        tableList: list,
        pagination,
      });
    });
  };

  filterFormItems = (data, level, type) => {
    const { roleTp } = bus.userInfo;
    let newFormItems = JSON.parse(JSON.stringify(data));



    if (roleTp !== 1 && roleTp !== 2) {
      newFormItems = newFormItems.filter(
        (item) =>
          item.key !== "newUserDeductRate" && item.key !== "incomeDeductRate" && item.key !== "createUserDeductRate"
      );
    } else if (level === 3) {
      newFormItems[2].onChange = this.handleFirstChannelChange.bind(this);
    }

    if (roleTp === 5) {
      newFormItems = newFormItems.filter(
        (item) => item.key !== "firstId" && item.key !== "parentId"
      );
    }

    if (roleTp === 4) {
      if (level === 2) {
        newFormItems = newFormItems.filter((item) => item.key !== "parentId");
      }
      if (level === 3) {
        let subs = [];

        if (allTreeData.length > 0) {
          subs = allTreeData[0].sub;
        }
        const subsOptions = subs.map((item) => ({
          label: item.name,
          value: item.id,
        }));

        newFormItems = newFormItems.filter((item) => {
          if (item.key === "parentId") {
            item.label = "父渠道";
            item.message = "请选择父级渠道";
            item.options = subsOptions;
          }

          return item.key !== "firstId";
        });
      }
    }

    if (level === 2) {
      newFormItems = newFormItems.filter(
        (item) =>
          item.key !== "newUserDeductRate" && item.key !== "incomeDeductRate" && item.key !== "createUserDeductRate"
      );
    }

    if (level !== 3) {
      newFormItems = newFormItems.filter(
        (item) =>
          item.key !== "createUserDeductRate"
      );

    }


    return newFormItems;
  };

  newChannel = async (level, isMore = false) => {
    let formValue = { isCooperation: 1 };
    let tempFormItems = form["formItems_" + level];

    tempFormItems = this.filterFormItems(tempFormItems, level, 'new');

    if (level === 3) {
      const res = await getChannelCode();

      if (res.data.meta.errCode === 0) {
        formValue.codes = res.data.data.code;
      } else {
        message.error(`生成渠道号失败,请再次尝试创建`);
        return;
      }
    }

    // 三级渠道批量创建
    if (isMore) {
      const temp = {
        key: "limit",
        label: "批量创建数量",
        componentName: "inputNumber",
        min: 1,
        max: 1000,
        require: true,
        message: "请填写批量创建数量",
      };

      tempFormItems.splice(4, 0, temp);
    }

    let checkbox = [
      {
        key: "createAcc",
        componentName: "checkbox",
        placeholder: "创建渠道同时创建登录账户",
      },
    ];


    this.setState({
      formItems: tempFormItems.concat(checkbox),
      operateType: "create",
      formDefaultValue: formValue,
      id: "",
      level: level,
    });
    this.showModal();
  };

  editRow = (row) => {
    const { roleTp } = bus.userInfo;
    const { id, level } = row;

    this.setState({ id, level });

    let formValue = {
      name: row.name,
      rewardRate: row.reward ? (row.reward.Rate / 100).toFixed(2) : "",
      isCooperation: row.isCooperation
    };
    let tempFormItems = form["formItems_" + level];


    tempFormItems = this.filterFormItems(tempFormItems, level);

    if (row.hideTargetIds) {
      formValue.hideTargetIds = JSON.parse(JSON.stringify(row.hideTargetIds));
    }


    if (row.company) {
      formValue.company = row.company.name;
      formValue.contact = row.company.contact;
      formValue.mobile = row.company.mobile;
      formValue.address = row.company.address;
    }

    if (roleTp === 1 || roleTp === 2) {
      if (row.level === 3) {
        const tempFirst = row.parent.parentId;

        tempFormItems[3].options = this.getSecondChannelByFirstChannel(
          tempFirst
        );

        formValue.firstId = tempFirst;
      }
    }

    if (row.parentId) {
      formValue.parentId = row.parentId;
    }

    if (row.codes) {
      formValue.codes = row.codes.join(",");
    }

    if (row.deduct) {
      Object.assign(formValue, {
        newUserDeductRate:
          row.deduct.newUserDeduct && row.deduct.newUserDeduct.latestRate,
        incomeDeductRate:
          row.deduct.incomeDeduct && row.deduct.incomeDeduct.latestRate,
        createUserDeductRate:
          row.deduct.createUserDeduct && row.deduct.createUserDeduct.latestRate
      });
    }

    this.setState({
      formItems: tempFormItems,
      operateType: "edit",
      formDefaultValue: formValue,
    });
    this.showModal();
  };


  getAllTarget = (oriParams = {}) => {
    let params = Object.assign(
      { userId: bus.me.data.accountInfo.id },
      oriParams
    );

    getAllTarget(params).then((res) => {
      const data = res.data.data || {};
      const meta = res.data.meta;
      if (meta && meta.errCode === 0) {
        const allTarget = data.allTarget || [];
        const options = allTarget.map(({ targetId: value, targetName: label }) => {
          return {
            value,
            label
          }
        })

        hideOptions = options;

        form.formItems_1.map(item => {
          if (item.key === "hideTargetIds") {
            item.options = hideOptions
          }
          return item
        })
      }

    });
  };

  deleteRow = (row) => {
    confirm({
      title: `您确定删除该渠道吗?`,
      content: `${row.level === 1 ? "该一级渠道下的所有二级渠道都将被删除" : ""
        }`,
      okText: "删除",
      okType: "danger",
      cancelText: "取消",
      onOk: () => {
        deleteChannel({ id: row.id }).then((res) => {
          if (res.data.meta.errCode === 0) {
            message.success("删除成功!");
            this.getChannelList(this.state.pagination.current);
          } else {
            message.error(
              `删除失败!${res.data.meta.errCode} - ${res.data.meta.errMsg}`
            );
          }
        });
      },
      onCancel: () => { },
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  dateFormmat = (timestamp) => {
    return timestamp
      ? moment(new Date(timestamp * 1000)).format(dateFormat)
      : "--";
  };

  onDateChange = (data, btntag) => {
    const { start: createBegin, end: createEnd } = data;

    this.setState({ createBegin, createEnd });
    console.log(data);
  };

  handleDownload = () => {
    const { groupId, subGroupId, name, createBegin, createEnd } = this.state;
    const params = {
      groupId,
      subGroupId,
      name,
    };

    if (createBegin && createEnd) {
      Object.assign(params, { createBegin, createEnd });
    }

    download(params).then(res => {
      downloadjs(res.data);
    });
  };

  render() {
    let columns = [
      {
        title: "渠道级别",
        dataIndex: "level",
        align: "center",
      },
      {
        title: "一级渠道",
        dataIndex: "level1",
        align: "center",
        render: (text, record, index) => {
          if (record.level === 1) {
            return <span>{record.name}</span>;
          } else if (record.level === 2) {
            return <span>{record.parent ? record.parent.name : ""}</span>;
          } else {
            return (
              <span>
                {record.parent &&
                  record.parent.parent &&
                  record.parent.parent.name}
              </span>
            );
          }
        },
      },
      {
        title: "二级渠道",
        dataIndex: "level2",
        align: "center",
        render: (text, record, index) => {
          if (record.level === 2) {
            return <span>{record.name}</span>;
          } else if (record.level === 3) {
            return <span>{record.parent ? record.parent.name : ""}</span>;
          } else {
            return <span />;
          }
        },
      },
      {
        title: "三级渠道",
        dataIndex: "level3",
        align: "center",
        render: (text, record, index) => {
          if (record.level === 3) {
            return <span>{record.name}</span>;
          } else {
            return <span />;
          }
        },
      },
      {
        title: "分成比例",
        dataIndex: "reward",
        width: 100,
        align: "center",
        render: (text, record, index) => {
          return <span>{text ? (text.Rate / 100).toFixed(2) + "%" : ""}</span>;
        },
      },
      {
        title: "新增扣量",
        dataIndex: "newUserDeductRate",
        width: 100,
        align: "center",
        render: (text, record, index) => {
          const newUserDeduct = record.deduct && record.deduct.newUserDeduct;

          return (
            <span>
              {newUserDeduct ? newUserDeduct.latestRate + "%" : "---"}
            </span>
          );
        },
      },
      {
        title: "收入扣量",
        dataIndex: "incomeDeductRate",
        width: 100,
        align: "center",
        render: (text, record, index) => {
          const incomeDeduct = record.deduct && record.deduct.incomeDeduct;

          return (
            <span>{incomeDeduct ? incomeDeduct.latestRate + "%" : "---"}</span>
          );
        },
      },
      {
        title: "首次创角扣量",
        dataIndex: "createUserDeductRate",
        width: 100,
        align: "center",
        render: (text, record, index) => {
          const deduct = (record.deduct && record.deduct.createUserDeduct) || {}
          return (
            <span>{deduct.latestRate ? deduct.latestRate + "%" : "---"}</span>
          );
        },
      },
      {
        title: "渠道号",
        align: "center",
        dataIndex: "codes",
        render: (text, record, index) => {
          return <span>{text ? text.join(", ") : ""}</span>;
        },
      },
      {
        title: "创建人",
        dataIndex: "creatorName",
        align: "center",
        render: (text, record, index) => {
          return <span>{text || "--"}</span>;
        },
      },
      {
        title: "创建时间",
        dataIndex: "createAt",
        align: "center",
        render: (text, record, index) => {
          return <span>{this.dateFormmat(text)}</span>;
        },
      },
      {
        title: "操作",
        align: "center",
        width: 200,
        dataIndex: "operation",
        render: (text, record, index) => (
          <div>
            <Button
              type="primary"
              onClick={() => {
                this.editRow(record);
              }}
            >
              编辑
            </Button>
            <Button
              type="danger"
              onClick={() => {
                this.deleteRow(record);
              }}
              style={{ marginLeft: 8 }}
            >
              删除
            </Button>
          </div>
        ),
      },
    ];

    const tp = bus.userInfo.roleTp;

    if (tp !== 1 && tp !== 2) {
      columns = columns.filter(
        (item) =>
          item.dataIndex !== "newUserDeductRate" &&
          item.dataIndex !== "incomeDeductRate" && item.dataIndex !== "createUserDeductRate"
      );
    }

    if (tp === 4) {
      // 一级渠道
      let tempColumns = [];

      columns.forEach((item) => {
        const isPass = item.dataIndex !== "level1";

        if (isPass) {
          if (item.dataIndex === "level2") {
            item.title = "子级渠道";
          }
          if (item.dataIndex === "level3") {
            item.title = "末级渠道";
          }
          tempColumns.push(item);
        }
      });

      columns = tempColumns;
    }

    if (tp === 5) {
      // 二级渠道
      let tempColumns = [];

      columns.forEach((item) => {
        const isPass =
          item.dataIndex !== "level1" && item.dataIndex !== "level2";

        if (isPass) {
          if (item.dataIndex === "level3") {
            item.title = "渠道名称";
          }
          tempColumns.push(item);
        }
      });

      columns = tempColumns;
    }

    return (
      <div>
        <h2 style={{ marginTop: 8 }}>渠道管理</h2>
        <Button
          type="primary"
          style={{
            marginTop: 18,
            display: bus.userInfo.roleTp < 4 ? "inline-block" : "none",
            marginRight: 10,
          }}
          onClick={() => {
            this.newChannel(1);
          }}
        >
          创建一级渠道
        </Button>
        <Button
          type="primary"
          style={{
            marginTop: 18,
            marginRight: 10,
            display: bus.userInfo.roleTp < 5 ? "inline-block" : "none",
          }}
          onClick={() => {
            this.newChannel(2);
          }}
        >
          {tp === 4 ? "创建子渠道" : "创建二级渠道"}
        </Button>
        <Button
          type="primary"
          style={{ marginTop: 18, marginRight: 10 }}
          onClick={() => {
            this.newChannel(3);
          }}
        >
          {tp === 5 ? "创建子渠道" : tp === 4 ? "创建末级渠道" : "创建三级渠道"}
        </Button>
        <Button
          type="primary"
          style={{
            marginTop: 18,
            display: bus.userInfo.roleTp < 3 ? "inline-block" : "none",
          }}
          onClick={() => {
            this.newChannel(3, true);
          }}
        >
          批量创建三级渠道
        </Button>
        <div style={{ marginTop: 18 }}>
          <Select
            showSearch
            placeholder="请选择一级渠道"
            style={{
              width: 200,
              display: tp === 5 ? "none" : "block",
              marginRight: "8px",
              float: "left"
            }}
            defaultValue=""
            optionFilterProp="children"
            onChange={this.selectChannel}
            allowClear={true}
          >
            {this.state.channelTree.map((ele) => {
              return (
                <Option key={ele.id} value={ele.id}>
                  {ele.name}
                </Option>
              );
            })}
          </Select>
          <Input
            placeholder="输入查询的名字/渠道号"
            style={{
              width: "200px",
              float: "left"
            }}
            onChange={this.getInputVal}
          />
          <div style={{ float: "left", marginTop: '-20px' }}>
            <DateGroup
              onDateChange={this.onDateChange}
              btns={[]}
              defaultValue={'0'}
              isDeducted={false}
              style={{ marginTop: '-18px' }}
            />
          </div>
          <Button
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={() => {
              this.searchChannel({ current: 1 });
            }}
          >
            搜索
          </Button>
          <Button
            type="primary"
            style={{
              float: 'right',
              display: (bus.userInfo.perCodes || []).includes('*') ? "block" : "none"
            }}
            onClick={() => {
              this.handleDownload();
            }}
          >
            下载
          </Button>
        </div>
        <Table
          locale={{ emptyText: "暂无数据" }}
          rowKey={(record) => record.id}
          style={{ marginTop: 18 }}
          pagination={this.state.pagination}
          columns={columns}
          onChange={(page, pageSize) => {
            this.searchChannel(page);
          }}
          dataSource={this.state.tableList}
        />
        <Modal
          title={this.state.operateType === "create" ? "创建" : "编辑"}
          width="900px"
          visible={this.state.visible}
          destroyOnClose={true}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText="确认"
          cancelText="取消"
        >
          <div style={{ maxHeight: "600px", overflowY: "auto" }}>
            <FormSummary
              labelCols={5}
              operateType={this.state.operateType}
              formDefaultValue={this.state.formDefaultValue}
              ref={this.formRef}
              formItems={this.state.formItems}
            />
          </div>
        </Modal>
      </div>
    );
  }
}
